import { graphql } from 'gql.tada';

export const StaffMemberFragment = graphql(`
  fragment StaffMemberFragment on StaffMember {
    id
    kind
    state
    startedOn
    endedOn
    employeeId
    title
    person {
      id
      firstName
      lastName
    }
  }
`);

export const StaffMemberDetailFragment = graphql(`
  fragment StaffMemberDetailFragment on StaffMember {
    id
    kind
    state
    startedOn
    endedOn
    employeeId
    title
    loginState
    person {
      id
      firstName
      lastName
      email
    }
    currentAndFutureClassInstructorships {
      id
      role
      classOffering {
        id
        displayName
        slug
        course {
          id
          name
          slug
          schoolYear {
            id
            slug
          }
        }
        term {
          id
          name
        }
      }
    }
    classInstructorships {
      id
      role
      classOffering {
        id
        displayName
        slug
        course {
          id
          name
          slug
          schoolYear {
            id
            slug
          }
        }
        term {
          id
          name
        }
      }
    }
  }
`);
